export function ReceiptEmpty({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="200"
        height="124"
        viewBox="0 0 200 124"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M60 34C60 26 64 22 72 22H128C136 22 140 26 140 34V112C139.801 113.454 139.014 114.792 137.789 115.762C136.564 116.733 134.985 117.268 133.35 117.268C131.715 117.268 130.136 116.733 128.911 115.762C127.686 114.792 126.899 113.454 126.7 112C126.7 113.591 125.994 115.117 124.738 116.243C123.481 117.368 121.777 118 120 118C118.223 118 116.519 117.368 115.262 116.243C114.006 115.117 113.3 113.591 113.3 112C113.101 113.454 112.314 114.792 111.089 115.762C109.864 116.733 108.285 117.268 106.65 117.268C105.015 117.268 103.436 116.733 102.211 115.762C100.986 114.792 100.199 113.454 100 112C99.8006 113.454 99.0143 114.792 97.7894 115.762C96.5644 116.733 94.9855 117.268 93.35 117.268C91.7145 117.268 90.1356 116.733 88.9106 115.762C87.6857 114.792 86.8994 113.454 86.7 112C86.7 113.591 85.9941 115.117 84.7376 116.243C83.4811 117.368 81.777 118 80 118C78.223 118 76.5189 117.368 75.2624 116.243C74.0059 115.117 73.3 113.591 73.3 112C73.1006 113.454 72.3143 114.792 71.0894 115.762C69.8644 116.733 68.2855 117.268 66.65 117.268C65.0145 117.268 63.4356 116.733 62.2106 115.762C60.9857 114.792 60.1994 113.454 60 112V34Z"
          fill="var(--clr-container-bg)"
          stroke="var(--clr-border-grey-100)"
        />
        <path
          d="M84 56C88 60.6667 92 60.6667 96 56"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          d="M104 56C108 60.6667 112 60.6667 116 56"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          d="M92 70C97.3333 74 102.667 74 108 70"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          opacity="0.18"
          d="M78.5 68.5C80.1569 68.5 81.5 67.1569 81.5 65.5C81.5 63.8431 80.1569 62.5 78.5 62.5C76.8431 62.5 75.5 63.8431 75.5 65.5C75.5 67.1569 76.8431 68.5 78.5 68.5Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.18"
          d="M118.5 68.5C120.157 68.5 121.5 67.1569 121.5 65.5C121.5 63.8431 120.157 62.5 118.5 62.5C116.843 62.5 115.5 63.8431 115.5 65.5C115.5 67.1569 116.843 68.5 118.5 68.5Z"
          fill="var(--clr-general-primary)"
        />
        <path
          d="M72 92.5H124C123.337 92.5 122.701 92.4473 122.232 92.3536C121.763 92.2598 121.5 92.1326 121.5 92C121.5 91.8674 121.763 91.7402 122.232 91.6464C122.701 91.5527 123.337 91.5 124 91.5H72C72.663 91.5 73.2989 91.5527 73.7678 91.6464C74.2366 91.7402 74.5 91.8674 74.5 92C74.5 92.1326 74.2366 92.2598 73.7678 92.3536C73.2989 92.4473 72.663 92.5 72 92.5Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.75"
          d="M72 103.5H108C107.337 103.5 106.701 103.447 106.232 103.354C105.763 103.26 105.5 103.133 105.5 103C105.5 102.867 105.763 102.74 106.232 102.646C106.701 102.553 107.337 102.5 108 102.5H72C72.663 102.5 73.2989 102.553 73.7678 102.646C74.2366 102.74 74.5 102.867 74.5 103C74.5 103.133 74.2366 103.26 73.7678 103.354C73.2989 103.447 72.663 103.5 72 103.5Z"
          fill="var(--clr-general-primary)"
        />
        <path
          d="M36 29C41.3333 35.6667 48.3333 39.6667 57 41"
          stroke="var(--clr-title)"
          strokeOpacity="0.2"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeDasharray="1 7"
        />
        <path
          opacity="0.9"
          d="M31 26.0005C25.6673 21.1464 26.1563 14.8408 31.7362 12.4189C35.1283 17.7569 34.3973 23.0922 31 26.0005Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.65"
          d="M31 26.0001C25.6621 29.3922 19.8429 26.7206 18.3914 20.8988C24.2131 19.4473 28.8201 21.3905 31 26.0001Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.45"
          d="M164 92L166 97L171 99L166 101L164 106L162 101L157 99L162 97L164 92Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.4"
          d="M105 10.6004C106.436 10.6004 107.6 9.43633 107.6 8.00039C107.6 6.56445 106.436 5.40039 105 5.40039C103.564 5.40039 102.4 6.56445 102.4 8.00039C102.4 9.43633 103.564 10.6004 105 10.6004Z"
          fill="var(--clr-general-primary)"
        />
      </svg>
    </span>
  );
}
